// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + {"56":"5959ecc20cf73eef6379","254":"b3ff59cdcba0b191b9f8","318":"5e50dd22cc1233dbfe79","393":"9a35c283a1b1b1769fff","540":"6244702747947a6fee6d","848":"d28cda3f3985c70670e4","961":"113a709230095649c50b"}[chunkId] + ".js";
};